import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class serviceBox extends React.Component {
    render() {
        return (
            <div className="service-box">
                <FontAwesomeIcon icon={this.props.iconName} className="service-box-icon" />
                <h3 className="service-box-title">{this.props.title}</h3>
                <div className="service-box-description">{this.props.description}</div>
            </div>
        )
    }
}

export default serviceBox